export enum LessonAssetLinkLaunchError {
  MaterialNotFound = 'materialNotFound',
  ProductNotFound = 'productNotFound',
}

export type LessonAssetLinkLaunchResult = { path: string } | { error: LessonAssetLinkLaunchError };
